import React, { forwardRef } from 'react'
import { Fab, FabProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

const useStyles = makeStyles(
  theme => ({
    marketingStyleButton: {
      fontSize: '1.6rem',
      backgroundColor: theme.colors.loginButtonBackground,
      '&&&&:hover': {
        backgroundColor: theme.colors.loginButtonBackground,
      },
    },
  }),
  { name: 'MarketingStyleButton' },
)

export interface MarketingStyleButtonProps extends FabProps {
  readonly className?: string
}

const MarketingStyleButton = forwardRef<
HTMLButtonElement,
MarketingStyleButtonProps
>(function MarketingStyleButton({ children, className, ...rest }, ref) {
  const classes = useStyles()

  return (
    <Fab
      className={classNames(classes.marketingStyleButton, className)}
      color="secondary"
      ref={ref}
      variant="extended"
      {...rest}
    >
      {children}
    </Fab>
  )
})

export default MarketingStyleButton
